import slugify from "slugify";

export const slugifyLowered = (str: string) => slugify(str.toLowerCase())
